module.exports = __webpack_public_path__ + "a4af0f12cc37938a0119884e1e48a1d0.png";